import { SET_LANG } from '../types/types';

const setLang = payload => ({
    type: SET_LANG,
    payload
});

export default setLang;
